export const loading = state => {
  return state.loading;
};

export const isLoggedIn = state => {
  return state.isLoggedIn;
};

export const layoutConfig = state => {
  return state.layoutConfig;
};

export const getKey = state => {
  return state.key;
};
